import { Reveal, SectionHead } from "./Reveal";

const ROWS = [
    {
        title: "Global Sourcing Network",
        text: "We work with over 100 manufacturers across the globe — sourcing specialised equipment to deliver custom solutions tailored to the problem at hand.",
    },
    {
        title: "Custom Engineering",
        text: "From a single bed to a full theatre fit-out: every requirement is studied, specified and built to fit the space, the team and the workflow.",
    },
    {
        title: "OT Design & R&D",
        text: "Dedicated research and development on operation theatre design — layout, lighting, integration and build.",
    },
    {
        title: "CSSD Development",
        text: "Research-driven CSSD planning — a sterile flow designed end to end, so sterility never travels backwards.",
    },
];

const STATS = [
    { value: "1986", label: "Established" },
    { value: "5", label: "Manufacturing Facilities" },
    { value: "2", label: "Branches" },
    { value: "100+", label: "Global OEM Partners" },
];

export default function Capabilities() {
    return (
        <section
            id="capabilities"
            data-testid="capabilities-section"
            className="relative overflow-hidden py-24 lg:py-32"
        >
            <div className="pointer-events-none absolute right-[-10%] top-1/3 h-[480px] w-[480px] rounded-full bg-mint/5 blur-[150px]" />
            <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="grid gap-14 lg:grid-cols-12">
                    <div className="lg:col-span-4">
                        <div className="lg:sticky lg:top-32">
                            <SectionHead
                                label="Beyond Manufacturing"
                                title="A single partner, end to end."
                            />
                            <Reveal delay={0.15}>
                                <p className="mt-6 max-w-sm text-base leading-relaxed text-slate-400">
                                    Manufacture is where we started. Design,
                                    R&amp;D and global sourcing are where we go
                                    further — for hospitals that need one
                                    accountable partner.
                                </p>
                            </Reveal>
                        </div>
                    </div>

                    <div className="lg:col-span-8">
                        {ROWS.map((r, i) => (
                            <Reveal key={r.title} delay={i * 0.06}>
                                <div
                                    data-testid={`capability-row-${i}`}
                                    className="group grid grid-cols-[auto_1fr] gap-6 border-t border-line py-9 transition-all duration-500 last:border-b hover:bg-white/[0.02] sm:gap-10 sm:px-4"
                                >
                                    <span className="pt-1 font-mono text-xs tracking-[0.2em] text-gold">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <div className="transition-transform duration-500 group-hover:translate-x-2">
                                        <h3 className="font-display text-xl font-bold text-white sm:text-2xl">
                                            {r.title}
                                        </h3>
                                        <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-400 sm:text-base">
                                            {r.text}
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>

                <Reveal y={36}>
                    <div
                        data-testid="stats-band"
                        className="mt-20 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-line bg-line lg:grid-cols-4"
                    >
                        {STATS.map((s) => (
                            <div
                                key={s.label}
                                className="flex flex-col items-start gap-2 bg-panel px-7 py-9 transition-colors duration-500 hover:bg-[#10131d] sm:px-9"
                            >
                                <span className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
                                    {s.value}
                                </span>
                                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                                    {s.label}
                                </span>
                            </div>
                        ))}
                    </div>
                </Reveal>

                <Reveal delay={0.1}>
                    <p className="mt-8 text-center font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">
                        Equipping hospitals across West Bengal, Assam &amp;
                        beyond
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
